import { EntityRepository, Repository } from "typeorm";
import { RmColumns } from "./rm-columns-entity";



@EntityRepository(RmColumns)
export class RmColumnsRepository extends Repository<RmColumns>{

}
